import { MouseEvent, TouchEvent, useRef, useState } from "react";
import { StarRating } from "./StarRating";

const users = [
  {
    name: "Richardson Costa",
    imgSrc: "/projeto/richardson.webp",
    comment:
      "Atendimento excelente, técnico profissional e educado. Produto bom e conforme o anunciado. A montagem foi muito rápida e a instalação foi conforme o combinado. Recomendo muito a empresa.",
  },
  {
    name: "Charliel Davi Gabriel",
    imgSrc: "/projeto/charlie.webp",
    comment: "Excelente atendimento super recomendo estou muito agradecido",
  },
  {
    name: "Marcela Santos",
    imgSrc: "/projeto/marcela.webp",
    comment: "Atendimento excelente super atenciosos estão de parabéns toda equipe",
  },
  {
    name: "Hildeson Souza",
    imgSrc: "/projeto/hildeson.webp",
    comment: "Muito bom, ótimo atendimento estão de parabéns",
  },
  {
    name: "Tailson Fernandes",
    imgSrc: "/projeto/tailson.webp",
    comment:
      "Obrigado pelo atendimento dou nota 10 para Fernanda, Paula e Grabriel Freitas, foram super educados e esclareceram minhas dúvidas, muito obrigado!",
  },
  {
    name: "Angelly Suzuki",
    imgSrc: "/projeto/angelly.webp",
    comment:
      "Olá! Quero agradecer ao Santana Credo por toda a atenção ao me atender. Antecipei o meu FGTS,e a rapidez foi de imediato. Estou muito satisfeita e super recomendo! Muito obrigada!",
  },
  {
    name: "Jéssica Mara",
    imgSrc: "/projeto/jessica.webp",
    comment:
      "Fui atendida pelo Walisson, atendimento diferenciado com qualidade. Muito atencioso, passa muita clareza pro cliente. Parabéns pelo trabalho 👏",
  },
  {
    name: "Fabi Freitas",
    imgSrc: "/projeto/fabi.webp",
    comment:
      "Fui muito bem atendida  pela Santana  cred tudo bem certinho  e muito rapido  obrigado  a todos   e caiu em  menos de  de meia hora na conta o Dinheiro  obrigado  a todos  são  muito confiaveis e certinho 👏👏👏",
  },
  {
    name: "Kleber Andosio da Silva",
    imgSrc: "/projeto/kleber.webp",
    comment:
      "Maravilhoso muito bom são profissionais de primeira linha são todos muito profissionais meus parabéns pela a atuação de todos que mim atendeu Deus abençoe muito",
  },
  {
    name: "Paloma de Oliveira Costa",
    imgSrc: "/projeto/paloma.webp",
    comment:
      "Agradeço pelo atendimento com a Fernanda que foi super educada e prestativa com meu atendimento! Ótima profissional",
  },
];

export const SectionRating = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    if (containerRef.current) {
      setIsDragging(true);
      setStartX(e.pageX - containerRef.current.offsetLeft);
      setScrollLeft(containerRef.current.scrollLeft);
    }
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;
    e.preventDefault();
    if (containerRef.current) {
      const x = e.pageX - containerRef.current.offsetLeft;
      const walk = (x - startX) * 1.5; // Ajuste a velocidade do deslize aqui
      containerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e: TouchEvent<HTMLDivElement>) => {
    if (containerRef.current) {
      setStartX(e.touches[0].pageX - containerRef.current.offsetLeft);
      setScrollLeft(containerRef.current.scrollLeft);
    }
  };

  const handleTouchMove = (e: TouchEvent<HTMLDivElement>) => {
    if (containerRef.current) {
      const x = e.touches[0].pageX - containerRef.current.offsetLeft;
      const walk = (x - startX) * 1.5; // Ajuste a velocidade do deslize aqui
      containerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  return (
    <section className="bg-primary-blue bg-blue-background animate-pop-up flex w-full justify-center p-8 py-12">
      <div className="flex w-full max-w-7xl flex-col items-center gap-8">
        <h2 className="text-center text-3xl font-semibold text-white">
          AMAMOS RECEBER AVALIAÇÕES DE NOSSOS CLIENTES!
        </h2>
        <div
          ref={containerRef}
          className="relative flex h-fit w-full cursor-grab overflow-hidden active:cursor-grabbing"
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
        >
          {users.map((user, index) => (
            <div key={index} className="mx-8 flex-shrink-0 flex-grow-0" style={{ width: "300px" }}>
              <div className="flex h-64 flex-col rounded-lg bg-white p-3">
                <div className="flex gap-2 border-b p-2">
                  <img
                    alt={user.name}
                    loading="lazy"
                    width="36"
                    height="36"
                    decoding="async"
                    style={{ color: "transparent" }}
                    srcSet={user.imgSrc}
                  />
                  <div className="flex flex-col gap-1">
                    <span>{user.name}</span>
                    <StarRating count={5} />
                  </div>
                </div>
                <p className="p-2">{user.comment}</p>
              </div>
            </div>
          ))}
        </div>
        <a
          href="https://wa.me/553432259969"
          rel="nofollow noreferrer"
          target="_blank"
          className="animate-grow-and-shrink bg-green-wpp-light flex w-fit items-center gap-4 whitespace-nowrap rounded-full p-5 px-10 text-lg font-semibold text-white"
        >
          <span>Fale conosco</span>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="whatsapp"
            className="svg-inline--fa fa-whatsapp h-5 w-5"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
            ></path>
          </svg>
        </a>
      </div>
    </section>
  );
};
